import { Box, Typography } from "@mui/material";

import CustomButton from "../input/CustomButton";
import PaperFragment from "../misc/PaperFragment";

export default function NoMatch(props) {
    return (
        <Box sx={{ mt: 4, textAlign: "center" }}>
            <Typography variant="h5" gutterBottom>
                Page not found
            </Typography>
            <CustomButton {...props} title="Back to menu" path="/" />
            <PaperFragment center value={<img src="https://http.cat/404.jpg" alt="Page not found" width="35%" />} />
        </Box>
    );
}
